// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> mulberry-at-rice-hope
// Generated: 2026-10-29T18:34:49.185Z
// Counts: 0 design, 25 content, 46 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, your home comes with an in-unit washer and dryer, a dishwasher and efficient appliances, and lawn service takes care of the yard. Step outside to the pool, clubhouse fitness center and playground, then see everything on our <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Resort-style perks, right at home</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spend summer afternoons at the resort-style pool and lazy river, keep up your routine in the clubhouse fitness center, and meet neighbors in the resident lounge, all just a short walk or drive from your front door at Rice Hope.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a bi-annual filter change, exterior pest control, 24-hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Single-family homes for rent in Port Wentworth’s Rice Hope</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Mulberry at Rice Hope, the week has room for more than errands: afternoons on the lazy river, evenings by the fire pit with neighbors, and a clubhouse lounge for when you need a change of scene from home. See everything on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk the trails around Indigo Lake, pick up groceries at The Market at Rice Hope, then get onto I-95 or Highway 21 for quick drives to Gulfstream, the Port of Savannah and Pooler shopping. Learn more about the area on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Rice Hope living, minutes from I-95</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Rice Hope your dog gets a community dog park, tree-lined sidewalks, and trails around Indigo Lake. Many homes also have their own yard and lawn care is included, so there's always green space close by. See the full <a href=\"/pet-policy\">pet policy</a> for details.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through all six plans in 3D, from the Brunswick and Durham to the McDowell and Chatham, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside six Mulberry at Rice Hope homes in 3D, including the Brunswick, Guilford, Chatham, McDowell, Pickens, and Durham. Pick a plan to walk through, then compare details on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Spacious Garages"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-75a6-75a8-a76c-185ca7b3616c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a single-family home with a white siding, black shutters, and a two-car garage."
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-ebfc-770f-a3df-2de5bfbc3edb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of townhomes and single-family homes with manicured lawns beside a lake"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Electronic Thermostat"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-7664-7197-b4c1-bb313ed80b59.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area and kitchen with a large window and sliding glass door."
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/019fbdb9-8b61-706b-8512-9dc875f2caaf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with a lazy river and waterslide."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1ec1-7579-9a4d-ed33992f8e24.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a community with a large swimming pool complex, playground, and parking lot."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1e68-772b-bac6-7d112be49e31.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, stationary bikes, elliptical, and weight bench."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/019fbdb9-8b2f-7318-a5d2-baabf5697599.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with waterslides, a lazy river, and a clubhouse."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1ec1-7579-9a4d-ed33992f8e24.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a community with a large swimming pool complex, playground, and parking lot."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-86c2-7477-ac7e-3d3e2186baac.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and island."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/019fbdb9-8b2f-7318-a5d2-baabf5697599.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with waterslides, a lazy river, and a clubhouse."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Resort Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1ebe-72f9-97e1-109146714fb7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a lazy river pool with lush green landscaping and palm trees."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lazy River"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-86fe-737b-bb93-8783db72ba50.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment fitness center with treadmills, ellipticals, weight bench, and dumbbells."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-889c-756c-b997-80e0e59ca075.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse exterior with palm trees and outdoor seating."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-2133-7382-9e19-54f2ae7aa142.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community lounge area with a round table and chairs, bar counter, and large windows overlooking the exterior."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Resident Lounge"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1e90-73e8-8fa8-bc5003ccfad7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style pool and splash pad with lounge chairs and picnic tables."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Splash Pad"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-ebfc-770f-a3df-2de5bfbc3edb.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Mulberry at Rice Hope single-family homes beside a lake in Port Wentworth"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-7664-7197-b4c1-bb313ed80b59.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living area and kitchen with a large window and sliding glass door."
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/019fbdb9-8b2f-7318-a5d2-baabf5697599.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with waterslides, a lazy river, and a clubhouse."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-9799-71ec-af11-dac26829e08c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious open-concept living and dining area with a modern kitchen."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-10fe-7657-bbf2-dd7fb36267b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story rental home with blue and white siding, front porch, and two-car garage"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-19a4-7139-9db2-57dce43f2863.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-889c-756c-b997-80e0e59ca075.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse exterior with palm trees and outdoor seating."
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fa1f-7048-86b0-056724fd0862.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse fitness center with treadmills, weights, and strength-training machines"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-1664-7624-afb4-3e24fd4e563e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "White two-story home with black shutters, a two-car garage, and a tree out front"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-1ebe-72f9-97e1-109146714fb7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a lazy river pool with lush green landscaping and palm trees."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Float the afternoon"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The resort-style pool has a lazy river, waterslides, and sunny lounge areas, so a slow Saturday is a short walk away."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Gather outdoors"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighbors meet at the fire pit, the amphitheater, the playgrounds, and the dog park, and the trails around Indigo Lake are close by."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The clubhouse lounge has tables, a bar counter, and big windows for quiet work, and the fitness center is close by for a break."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbdbb-a1bb-756b-8328-8729144c53c0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Green space and picnic areas at Tom Triplett Park near Port Wentworth"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Tom Triplett Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11697-2061-7734-82f9-e89ad648c0d9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings and single-family homes in a suburban neighborhood with trees and a pond in the background."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Trees and pond views"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-10fe-7657-bbf2-dd7fb36267b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story rental home with blue and white siding, a front porch and a two-car garage"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Single-Family Home"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe44-fb3b-75ee-bf51-1d642d56ed6c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the resort-style pool complex with a lazy river and waterslides"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Resort-Style Pool"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-9583-770b-ba93-ab40b58cc107.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious open-concept living area and kitchen with modern appliances and island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-889c-756c-b997-80e0e59ca075.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse exterior with palm trees and outdoor seating."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-0d00-7311-b600-8c50d283f98c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with white cabinets, granite countertops and stainless steel appliances"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167579/01a11695-86fe-737b-bb93-8783db72ba50.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse fitness center with treadmills, ellipticals, a weight bench and dumbbells"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "very professional, friendly, upfront and communicative"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167579/019fbe45-10fe-7657-bbf2-dd7fb36267b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story home with blue upper siding, white lower siding, brick accents, a front porch and a two-car garage"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
